

$(document).ready(function() {
  document.querySelectorAll('.custom-header-section nav.header__inline-menu li details.mega-menu').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (details.open) {
      document.body.classList.add('mega-menu-open');
    } else {
      document.body.classList.remove('mega-menu-open');
    }
  });
});

  
    // Cache the video element
    var video = $('.custom-banner__video video').get(0);
    var playButton = $('.custom-banner__videoright a');

    // Click event for the video play/stop button
    playButton.click(function() {
        if (video.paused) {
            video.play();  // Play the video
            playButton.addClass('playing'); // Add class when playing
            playButton.find('svg').css('fill', '#fff'); // Change SVG color when playing
        } else {
            video.pause();  // Pause the video
            playButton.removeClass('playing'); // Remove class when paused
            playButton.find('svg').css('fill', '#fff'); // Change SVG color when paused
        }
    });
    $(".best-featured__review-wrapper").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    centerMode: false,
    // centerPadding: '90px',
    centerPadding: '0px',
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16L1.5 8.5L9 1" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8.5 8.5L1 16" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></button>',
    appendArrows: '.best-featured__arrow',
    appendDots: '.best-featured__dots',
  
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          infinite:false,
          arrows: true,
          adaptiveHeight:true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          infinite:false,
          arrows: true,
          adaptiveHeight:true,
        },
      },
    ],
  });
      $(".customer-review__wrapper").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    centerMode: false,
    // centerPadding: '90px',
    centerPadding: '0px',
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="25" height="10" viewBox="0 0 25 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 5L7.5 9.33013L7.5 0.669874L0 5ZM24.5 4.25L6.75 4.25L6.75 5.75L24.5 5.75L24.5 4.25Z" fill="black"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="25" height="10" viewBox="0 0 25 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.5 5L17 0.669873V9.33013L24.5 5ZM0 5.75H17.75V4.25H0V5.75Z" fill="#000"/></svg></button>',
    appendArrows: '.customer-review__arrows',
  
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          infinite:false,
          arrows: true,
          adaptiveHeight:true,
        },
      },
           {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          infinite:false,
          arrows: true,
          adaptiveHeight:true,
        },
      },
    ],
  });

  	$(".accordion__title").on("click", function() {
		// e.preventDefault();
        
		var $this = $(this);
		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp();
            $(".accordion__item").removeClass("accoridan-wrapper__active");
			$(".accordion__title").removeClass("accordion-active");
			$('.accordion__arrow').removeClass('accordion__rotate');
		}
		$this.toggleClass("accordion-active");
        $(this).parent().toggleClass("accoridan-wrapper__active");
		$this.next().slideToggle();
		$('.accordion__arrow',this).toggleClass('accordion__rotate');
	});

    // Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
   $('.product-video').each(function() {
        var $section = $(this); // The current section
        var video = $section.find('video').get(0); // The video in this section
        var playButton = $section.find('.product-banner__btn a'); // The play/pause button in this section

        // Click event for the video play/stop button
        playButton.click(function() {
            if (video.paused) {
                video.play(); // Play the video
                playButton.addClass('playing'); // Add class when playing
                playButton.find('.play-icon').hide(); // Hide play icon
                playButton.find('.pause-icon').show(); // Show pause icon
            } else {
                video.pause(); // Pause the video
                playButton.removeClass('playing'); // Remove class when paused
                playButton.find('.play-icon').show(); // Show play icon
                playButton.find('.pause-icon').hide(); // Hide pause icon
            }
        });
    });

  $('.product-buy__video-btn a').each(function() {
    var $button = $(this); // The play/pause button
    var $videoWrapper = $button.closest('.product-buy__video-wrapper'); // The wrapper for video and button
    var video = $videoWrapper.find('video').get(0); // The video element

    // Click event for the video play/pause button
    $button.click(function() {
        if (video.paused) {
            video.play(); // Play the video
            $button.addClass('playing'); // Add class when playing
            $button.find('.play-icon').hide(); // Hide play icon
            $button.find('.pause-icon').show(); // Show pause icon
        } else {
            video.pause(); // Pause the video
            $button.removeClass('playing'); // Remove class when paused
            $button.find('.play-icon').show(); // Show play icon
            $button.find('.pause-icon').hide(); // Hide pause icon
        }
    });
});

    $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    asNavFor: ".slider-nav",
    infinite: false,
    draggable:false,
    prevArrow:
      '<button class="slick-prev slick-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.46967 5.47028C0.176777 5.76317 0.176777 6.23805 0.46967 6.53094L5.24264 11.3039C5.53553 11.5968 6.01041 11.5968 6.3033 11.3039C6.59619 11.011 6.59619 10.5361 6.3033 10.2433L2.06066 6.00061L6.3033 1.75797C6.59619 1.46508 6.59619 0.990203 6.3033 0.697309C6.01041 0.404416 5.53553 0.404416 5.24264 0.697309L0.46967 5.47028ZM1 6.75061L16 6.75061V5.25061L1 5.25061L1 6.75061Z" fill="black"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5303 6.53094C15.8232 6.23805 15.8232 5.76317 15.5303 5.47028L10.7574 0.69731C10.4645 0.404416 9.98959 0.404417 9.6967 0.69731C9.40381 0.990203 9.40381 1.46508 9.6967 1.75797L13.9393 6.00061L9.6967 10.2433C9.40381 10.5361 9.40381 11.011 9.6967 11.3039C9.98959 11.5968 10.4645 11.5968 10.7574 11.3039L15.5303 6.53094ZM15 5.25061L-6.55671e-08 5.25061L6.55671e-08 6.75061L15 6.75061L15 5.25061Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true
        },
      },
    ],
  });
  $(".slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
     draggable:false,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0644/6868/0804/files/back.png?v=1727765543"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0644/6868/0804/files/back.png?v=1727765543"></button>`,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false
        },
      },
    ],
  });

$(".discount-wrapper > h2").click(function() {
    // Check if the .discount-inner__wrapper is currently visible
    if ($(".discount-inner__wrapper").is(":visible")) {
      // If it is visible, slide it up (hide it)
      $(".discount-inner__wrapper").slideUp();
      // Remove the class 'active' from the .discount-wrapper div
      $(".discount-wrapper").removeClass("active");
    } else {
      // If it is not visible, slide it down (show it)
      $(".discount-inner__wrapper").slideDown();
      // Add the class 'active' to the .discount-wrapper div
      $(".discount-wrapper").addClass("active");
    }
  });
  
});